import { render, staticRenderFns } from "./verify-identity-with-otp.vue?vue&type=template&id=45967b70&scoped=true&"
import script from "./verify-identity-with-otp.vue?vue&type=script&lang=js&"
export * from "./verify-identity-with-otp.vue?vue&type=script&lang=js&"
import style0 from "./verify-identity-with-otp.vue?vue&type=style&index=0&id=45967b70&lang=scss&scoped=true&"
import style1 from "@/assets/auth-screen.scss?vue&type=style&index=1&id=45967b70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45967b70",
  null
  
)

component.options.__file = "verify-identity-with-otp.vue"
export default component.exports